import api from "@services/axios/apiManager";
import type { CustomerRealtimeSession } from "./orderRealtimeSession";

/**
 * 要一張訂單即時通知的通行證（C6）。
 *
 * 只帶 Authorization、不帶 X-Context：頻道以「客戶本人」為單位，跟目前選哪個身分無關，
 * 切換身分也不必重連。跟 trackingSessionApi.ts 分開放，純函式的測試才不會拖進 axios 攔截器。
 */
export async function fetchCustomerRealtimeSession(cusJwtToken: string): Promise<CustomerRealtimeSession> {
  const res = await api.post("/app-api/customer/realtime-session", undefined, {
    headers: { Authorization: `Bearer ${cusJwtToken}` },
  });
  const data = res?.data?.data as Partial<CustomerRealtimeSession> | undefined;
  if (
    !data ||
    typeof data.token !== "string" ||
    typeof data.channel !== "string" ||
    typeof data.realtime?.httpHost !== "string" ||
    typeof data.realtime?.wssUrl !== "string"
  ) {
    throw new Error("realtime-session 回應格式不正確");
  }
  return data as CustomerRealtimeSession;
}
